import React from "react";
import { Box } from "@mui/material";
import {
  AudioLines,
  Podcast,
  ScanText,
  BotMessageSquare,
  ClipboardPaste,
  Brain,
  FileInput,
  type LucideIcon,
} from "lucide-react";
import { SCRIBE_VISIBLE_TABS, type TabId } from "./scribeUi";

export interface TabSpec {
  id: TabId;
  Icon: LucideIcon;
  label: string;
  shortLabel: string;
}

// Icon set mirrors the landing page (LandingPage.tsx FEATURES) so the tools match the
// marketing surface. ClipboardPaste covers the Paste tool, which has no equivalent on the
// landing page.
export const TAB_SPECS: Record<TabId, TabSpec> = {
  audio: { id: "audio", Icon: AudioLines, label: "Audio", shortLabel: "Audio" },
  record: { id: "record", Icon: Podcast, label: "Record", shortLabel: "Record" },
  document: { id: "document", Icon: ScanText, label: "Document", shortLabel: "Doc" },
  docChat: { id: "docChat", Icon: BotMessageSquare, label: "Doc Chat", shortLabel: "Chat" },
  paste: { id: "paste", Icon: ClipboardPaste, label: "Paste", shortLabel: "Paste" },
  qa: { id: "qa", Icon: Brain, label: "Q&A Assist", shortLabel: "Q&A" },
  formFiller: { id: "formFiller", Icon: FileInput, label: "Form Filler", shortLabel: "Forms" },
};

export const RECORD_TAB_ID: TabId = "record";

/** The tools to show, in order. SCRIBE_VISIBLE_TABS is the single source. */
export const getVisibleTabSpecs = (): TabSpec[] =>
  SCRIBE_VISIBLE_TABS.filter((id) => id in TAB_SPECS).map((id) => TAB_SPECS[id]);

/** Red dot shown on the Record tool while a recording is live. */
export const RecordingDot: React.FC = () => (
  <Box
    component="span"
    role="img"
    aria-label="Recording"
    data-testid="recording-indicator"
    sx={{
      display: "inline-block",
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "var(--err)",
      flexShrink: 0,
    }}
  />
);
